import { Component, OnInit } from '@angular/core';
import { ComponentBase } from 'src/app/main/dynamic/component-base';
import { DynamicEvent } from 'src/app/main/dynamic/dynamic.event';

@Component({
  selector: 'app-textarea',
  templateUrl: './textarea.component.html',
  styleUrls: ['./textarea.component.scss']
})
export class TextareaComponent extends ComponentBase implements OnInit {

  private initialValue: string

  constructor() { super() }

  ngOnInit() {
  }

  private get valueChanged(): boolean {
    return this.initialValue != this.attribute.value
  }

  getHtmlText() {
    let convertedText = "Sem conteúdo";
    
    if(this.attribute.value) {
      convertedText = this.replaceURLs(this.attribute.value)
      convertedText = convertedText.split("\n").join("<br />");
    }

    return convertedText
  }

  private replaceURLs(message: string): string {
    if(!message) return;
   
    var urlRegex = /(((https?:\/\/)|(www\.))[^\s]+)/g;
    return message.replace(urlRegex, function (url) {
      var hyperlink = url;
      if (!hyperlink.match('^https?:\/\/')) {
        hyperlink = 'http://' + hyperlink;
      }
      return '<a href="' + hyperlink + '" target="_blank" rel="noopener noreferrer">' + url + '</a>'
    });
  }

  onMaxlength(event: any, size:string){
    if (size.length > 0 && 
        event.composedPath.length > +size) {
      return false
    }

    return true
  }

  onBlur() {
    if(this.valueChanged) {
      let events: DynamicEvent[] = []

      if(this.attribute.hasError && this.attribute.value) {
        this.attribute.hasError = false
        events.push({ name: "validate" })
      }

      events.push({ name: "autosave", data: "silently" })
      this.emitEvents(events)
    }
  }
}
